import axios from './axios';

const endPoint = '/music-studio-enquiry';


const create = (body) => {
    return axios.post(`${endPoint}`, {
        ...body
    });
}


export default {
    create
};